import { Typography } from "@mui/material";

export default function InputLabel({label}) {
    return <Typography variant="body2" gutterBottom px={'14px'}>{label}</Typography>
}